module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-menu menu"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-pic-cont"
  }, [_c('div', {
    staticClass: "user-pic fx-align b-r-50"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.logo_url || _vm.logo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo-top",
    on: {
      "click": _vm.handleLink
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-x-between fx-y-center"
  }, [_c('p', {
    staticClass: "user-name",
    on: {
      "click": _vm.handleLink
    }
  }, [_vm._v(_vm._s(_vm.userInfo.username || _vm.userInfo.phone))])])]), _vm._v(" "), _c('nav', [_c('ul', [_c('router-link', {
    class: {
      'active': _vm.active == 'index'
    },
    attrs: {
      "to": {
        name: 'index'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-index"
  }), _vm._v("首页")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'shops'
    },
    attrs: {
      "to": {
        name: 'shopsManage'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-shop"
  }), _vm._v("门店管理")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'pay'
    },
    attrs: {
      "to": {
        name: 'payCount'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-payment"
  }), _vm._v("收银管理")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'wechat'
    },
    attrs: {
      "to": {
        name: 'wxIndex'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-wechet"
  }), _vm._v("公众号管理")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'vmall'
    },
    attrs: {
      "to": {
        name: 'statistics'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-vmall"
  }), _vm._v("微商城管理")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'vip'
    },
    attrs: {
      "to": {
        name: 'vipManage'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-vipcard"
  }), _vm._v("会员卡管理")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'marketing'
    },
    attrs: {
      "to": {
        name: 'marketing'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-admin"
  }), _vm._v("营销工具")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'finance'
    },
    attrs: {
      "to": {
        name: 'financeList'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-report-form"
  }), _vm._v("财务报表")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'users'
    },
    attrs: {
      "to": {
        name: 'users',
        query: {
          type: 'userCenter'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-merchant"
  }), _vm._v("商户中心")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'clear'
    },
    attrs: {
      "to": {
        name: 'clearList'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-settlement"
  }), _vm._v("结算记录")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-59492588","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/Menu.vue
// module id = 851
// module chunks = 0